import * as Yup from 'yup';
import {SR_TYPES} from 'Utils/constants/genericConstants';

export const createValidationSchema = (isSubTypeMandatory = false, srType = '') => {
  return Yup.object({
    subType: isSubTypeMandatory
      ? Yup.string().required('Subtype is a required field')
      : Yup.string().notRequired(),
    vulnerabilityIndicator:
      srType === SR_TYPES.VULNERABILITY
        ? Yup.string().required('Vulnerability Indicator is a required field')
        : Yup.string().notRequired(),
  });
};

export const initialValues = {
  summary: '',
  subType: '',
  subStatus: '',
  channel: 'Phone',
  owner: '',
  thirdParty: '',
  thirdPartyPhone: '',
  receivedDate: null,
  transactionAmount: '',
  transactionDate: null,
  statusReason: '',
  comments: '',
  commentsIntern: '',
  vulnerabilityIndicator: '',
  buttonAction: '',
};

export const transcriptInitialState = {
  enabled: false,
  transcriptData: null,
};
